import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../data/servicesData';
import './Services.css';

export default function Services() {
  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="services-hero-content">
          <h1>Our Services</h1>
          <p>Expert alterations for all your clothing needs</p>
        </div>
      </div>

      <section className="services-list-section">
        <div className="services-list-container">
          <div className="services-intro">
            <h2>Alteration Services</h2>
            <p>
              We offer a comprehensive range of alteration services for all garment types.
              Prices are starting estimates and may vary based on fabric type, garment structure, and labor required. Walk in for an estimated quote. Call for more information.
            </p>
          </div>

          <div className="services-cards-grid">
            {servicesData.map((service) => (
              <Link
                to={`/services/${service.id}`}
                className="service-card-link"
                key={service.id}
              >
                <div className="service-category-card">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>

                  <div className="view-details">
                    View Details <i className="fas fa-arrow-right"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
